import { useEffect, useState } from "react";
import usePartMarketplaces from "../../data/usePartMarketplaces";
import { IPart, IPartMarketplaces } from "../../models/Part";
import Card from "../shared/Card/Card";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import SwitchInput from "../shared/Inputs/SwitchInput";
import LoadingWheel from "../shared/LoadingWheel";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { set } from "lodash";
import useSettings from "../../data/useSettings";


export default function PartMarketplaces({ part }: { part: IPart }) {
  const { t } = useTranslation("stock");
  const { register, handleSubmit, watch, setValue, reset } = useForm<IPartMarketplaces>();

  const { marketplaces, updateMarketplaces, possibleMarketplaces } =
    usePartMarketplaces(part.id);
  const { loading, settings } = useSettings();

  const [canListEbay   , setCanListEbay   ] = useState(false);
  const [canListPartPro, setCanListPartPro] = useState(false);
  const [canListShopify, setCanListShopify] = useState(false);

  useEffect(() => {
    if (!possibleMarketplaces.isLoading && possibleMarketplaces.data) {
      const marketplaces = possibleMarketplaces.data.data;
      setCanListEbay   (marketplaces.ebay    );
      setCanListPartPro(marketplaces.partPro );
      setCanListShopify(marketplaces.shopify );
    }
  }, [possibleMarketplaces.data, possibleMarketplaces.isLoading]);

  useEffect(() => {
    if (marketplaces.isLoading) return;
    if (!marketplaces.data?.data) return;

    reset({
      id: marketplaces.data.data.id,
      ebay: marketplaces.data.data.ebay,
      partPro: marketplaces.data.data.partPro,
      shopify: marketplaces.data.data.shopify,
    });
  }, [marketplaces.data, marketplaces.isLoading]);


  const onSubmit = (data: IPartMarketplaces) => {
    updateMarketplaces.mutate(data);
  }

  return (
    <Card title={t("Marketplaces")} bodyClassName="px-6 py-5">
      {
        marketplaces.isLoading ?
          <LoadingWheel /> :
          <>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              {canListEbay && (
                <SwitchInput label="Ebay" register={register} registerName={"ebay"} watch={watch} setValue={setValue} groupClasses="!justify-between" />
              )}
              {canListPartPro && (
                <SwitchInput label="Part Pro" register={register} registerName={"partPro"} watch={watch} setValue={setValue} groupClasses="!justify-between" />
              )}
              {canListShopify && (
                <SwitchInput label="Shopify" register={register} registerName={"shopify"} watch={watch} setValue={setValue} groupClasses="!justify-between" />
              )}

              <ButtonInput isSubmit={true} label={t("Save")} classes="mt-10" onClick={() => { }} />
            </form>
          </>
      }
    </Card>
  );
};